/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
import React, { ReactElement, useRef, useState } from 'react';
import { FeaturedOfferProps } from './FeaturedOffer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import './index.css';

interface MktFeaturedOffersProps {
  children: ReactElement<FeaturedOfferProps>[];
  autoplaySpeedTransition?: number;
}

const DEFAULT_AUTOPLAY_SPEED = 5000;

export const MktFeaturedOffers: React.FC<MktFeaturedOffersProps> = ({
  children,
  autoplaySpeedTransition = DEFAULT_AUTOPLAY_SPEED,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const handleChange = (activeIndex: number) => {
    setActiveIndex(activeIndex);
  };

  //@ts-ignore
  const swiperRef = useRef<Swiper>() as React.MutableRefObject<Swiper>;

  const handleNextSlide = () => {
    const isFinished =
      children.length === swiperRef.current.swiper?.activeIndex + 1;
    isFinished
      ? swiperRef.current.swiper?.slideTo(0)
      : swiperRef.current.swiper?.slideNext();
  };
  const handlePrevSlide = () => {
    const isStarted = swiperRef.current.swiper?.activeIndex === 0;
    isStarted
      ? swiperRef.current.swiper.slideTo(children.length)
      : swiperRef.current.swiper.slidePrev();
  };

  return (
    <div className="whl-relative whl-pb-7 lg:whl-mx-auto lg:whl-max-w-[1000px] xl:whl-max-w-[1150px]">
      <Swiper
        ref={swiperRef}
        slidesPerView={1}
        onActiveIndexChange={i => handleChange(i.activeIndex)}
        centeredSlides
        autoplay={{
          delay: autoplaySpeedTransition,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, Pagination]}
        className="whl-mx-4 whl-flex whl-w-screen whl-flex-col whl-items-center lg:whl-w-[100%] xl:whl-w-full xl:whl-flex-row "
      >
        {children.map((child, i) => {
          return (
            <SwiperSlide
              key={i}
              className="whl-flex whl-w-screen whl-items-center whl-justify-center"
            >
              {child}
            </SwiperSlide>
          );
        })}
      </Swiper>
      {children.length > 1 && (
        <div className="whl-z-[2000] whl-flex whl-justify-center whl-gap-[20px] lg:whl-gap-[70px] ">
          <button
            type="button"
            className=" whl-border-blue-dark whl-text-blue-dark lg:whl-absolute lg:whl-left-[0px] lg:whl-top-[50%] lg:whl-z-[50000] lg:whl-translate-y-[-50%]"
            onClick={handlePrevSlide}
          >
            <i className="whl-icon iconSlider wh-icon-arrow-line-left whl-flex whl-h-[58.88px] whl-w-[59.32px] whl-items-center whl-justify-center whl-rounded-full whl-border whl-text-xl" />
          </button>

          <div className="whl-flex whl-items-center whl-justify-center whl-gap-4 lg:whl-hidden">
            <span className=" whl-flex whl-justify-center whl-text-[20px] whl-font-[400] whl-leading-[37px] whl-tracking-[2.3px]  whl-text-blue-dark ">
              0{activeIndex + 1}
            </span>
            <span className=" whl-flex whl-justify-center whl-text-[20px] whl-font-[400] whl-leading-[37px] whl-tracking-[2.3px]  whl-text-blue-dark">
              -
            </span>
            <span className=" whl-flex whl-justify-center whl-text-[20px] whl-font-[400] whl-leading-[37px] whl-tracking-[2.3px]  whl-text-blue-dark">
              0{children.length}
            </span>
          </div>
          <button
            type="button"
            className="whl-border-blue-dark whl-text-blue-dark lg:whl-absolute lg:whl-right-[0px] lg:whl-top-[50%] lg:whl-z-[50000] lg:whl-translate-y-[-50%]"
            onClick={handleNextSlide}
          >
            <i className="whl-icon iconSlider wh-icon-arrow-line-right whl-flex whl-h-[58.88px] whl-w-[59.32px] whl-items-center whl-justify-center whl-rounded-full whl-border whl-text-xl whl-text-blue-dark" />
          </button>
        </div>
      )}
    </div>
  );
};
